<header style="margin-bottom: 55px;" class="border shadow-lg">
    <nav class="row px-3 py-2 fixed-top bg-white">

        <div class="col-1">
            <div class="pointer">
                <img routerLink="orders/orders-list" src="assets/img/logo.png" height="40">
            </div>
        </div>

        <div class="col-6">
            <ul class="nav justify-content-end b-md-0">
                <!-- Menú Orders - Requiere permiso orders.view -->
                <li *hasPermission="'orders.view'" 
                    routerLinkActive="active" 
                    routerLink="orders/orders-list">
                    <a class="nav-link px-2">Orders</a>
                </li>

                <!-- Menú Customers - Requiere permiso customers.view -->
                <li *hasPermission="'customers.view'" 
                    routerLinkActive="active" 
                    routerLink="customers/customers-list">
                    <a class="nav-link px-2">Customers/Third Party</a>
                </li>

                <!-- Menú Payments - Requiere permiso payments.view -->
                <li *hasPermission="'payments.view'">
                    <div class="dropdown text-end">
                        <div class="d-grid d-md-flex justify-content-end" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <a class="nav-link px-2">Payments</a>
                            <div style="margin-top: 10px !important; margin-left: -5px !important;">
                                <i class="h5 fi fi-ss-angle-small-down" style="padding-bottom: 1.1px;"></i>
                            </div>
                        </div>
                        <ul class="dropdown-menu text-small">
                            <li routerLink="payments/client-payment-list"><a class="dropdown-item">Customer / Third
                                    Party</a></li>
                            <li routerLink="payments/driver-payment-list"><a class="dropdown-item">Drivers</a></li>
                            <li routerLink="payments/customer-document-movements"><a class="dropdown-item">Document Movements</a></li>
                        </ul>
                    </div>
                </li>

                <!-- Menú Catalogs - Requiere permiso catalogs.view -->
                <li *hasPermission="'catalogs.view'">
                    <div class="dropdown text-end">
                        <div class="d-grid d-md-flex justify-content-end" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <a class="nav-link px-2">Catalogs</a>
                            <div style="margin-top: 10px !important; margin-left: -5px !important;">
                                <i class="h5 fi fi-ss-angle-small-down" style="padding-bottom: 1.1px;"></i>
                            </div>
                        </div>
                        <ul class="dropdown-menu text-small">
                            @for (x of catalogs; track $index) {
                            <li><a class="dropdown-item" [routerLink]="x.route">{{ x.descr }}</a></li>
                            }
                            <li *hasPermission="'admin.system_settings'"><a class="dropdown-item" (click)="OpenPreferencesModal()">Global Preferences</a></li>
                        </ul>
                    </div>
                </li>

                <!-- Menú Accounting - Solo para Admin/usuarios con permisos -->
                <li *hasRole="'Admin'" routerLinkActive="active" routerLink="accounting/invoice-journals">
                    <a class="nav-link px-2">Accounting</a>
                </li>

                <!-- Menú Reports - Requiere permiso reports.view -->
                <li *hasPermission="'reports.view'">
                    <div class="dropdown text-end">
                        <div class="d-grid d-md-flex justify-content-end" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <a class="nav-link px-2">Reports</a>
                            <div style="margin-top: 10px !important; margin-left: -5px !important;">
                                <i class="h5 fi fi-ss-angle-small-down" style="padding-bottom: 1.1px;"></i>
                            </div>
                        </div>
                        <ul class="dropdown-menu text-small">
                            <li routerLink="reports/driver-daily-log"><a class="dropdown-item">Driver Daily Log</a></li>
                            <li routerLink="reports/aging-summary"><a class="dropdown-item">Aging Summary Report</a>
                            </li>
                            <li routerLink="reports/movement-detail"><a class="dropdown-item">Movement Detail Report</a></li>
                        </ul>
                    </div>
                </li>

                <!-- Menú Admin - Requiere permiso admin.view -->
                <li *hasPermission="'admin.view'">
                    <div class="dropdown text-end">
                        <div class="d-grid d-md-flex justify-content-end" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <a class="nav-link px-2">Admin</a>
                            <div style="margin-top: 10px !important; margin-left: -5px !important;">
                                <i class="h5 fi fi-ss-angle-small-down" style="padding-bottom: 1.1px;"></i>
                            </div>
                        </div>
                        <ul class="dropdown-menu text-small">
                            <li *hasPermission="'admin.manage_users'" routerLink="admin/users"><a class="dropdown-item">Users</a></li>
                            <li *hasPermission="'admin.manage_roles'" routerLink="admin/roles"><a class="dropdown-item">Roles & Permissions</a></li>
                        </ul>
                    </div>
                </li>

                @if (roles.includes('Employee')) {
                <li routerLinkActive="active" routerLink="customers/portal">
                    <a class="nav-link px-2">Appointments & Deliveries</a>
                </li>

                <li routerLinkActive="active" routerLink="customers/history">
                    <a class="nav-link px-2">History</a>
                </li>
                }
            </ul>
        </div>

        <div class="col-5">
            <div class="row mt-2">
                <div class="col-10">
                    <div class="d-grid d-flex gap-3 justify-content-center">

                        @if (roles.includes('Admin')) {
                        <div>
                            <div class="input-group search_order">
                                <input class="form-control" [(ngModel)]="proId" (keydown.enter)="SearchNewOrder()">
                                <span (click)="SearchNewOrder()" class="input-group-text text-primary pointer">
                                    <i class="fi fi-rr-search"></i>
                                </span>
                            </div>
                        </div>
                        }

                        <div class="d-flex" style="margin-top: 3px;"
                            [ngClass]="roles[0] == 'Employee' ? 'custom_margin' : ''">
                            <img src="assets/img/user.png" width="20" height="20" class="rounded-circle me-2">
                            <small>{{ fullName }}</small>
                        </div>

                    </div>
                </div>
                <div class="col-2">
                    <div>
                        <div class="dropdown text-end">
                            <span class="d-block rounded pointer" data-bs-toggle="dropdown" aria-expanded="false">
                                <div class="pt-1"></div>
                                <i class="h5 px-2 fi fi-ss-menu-burger text-primary"></i>
                            </span>
                            <ul class="dropdown-menu text-small">
                                <!-- <li>
                                    <hr class="dropdown-divider">
                                </li> -->
                                <li><a (click)="LogOut()" class="dropdown-item">Sign out</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </nav>
</header>


<app-custom-toast></app-custom-toast>


<!-- APPLICATION PREFERENCES -->
<div class="modal modal-lg fade" id="preferenceConfig" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="width: 600px !important;">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5">
                    Global Preferences
                </h1>
                <a type="button" data-bs-dismiss="modal">
                    <i class="h5 fi fi-rr-circle-xmark"></i>
                </a>
            </div>
            <div class="modal-body">

                <div class="row px-4">
                    <div class="col-5">

                        <div class="mt-3 row">
                            <div class="d-grid gap-3 d-md-flex justify-content-start">
                                <h5 class="modal-title" style="font-size: 17px;">
                                    Order's Configuration
                                </h5>
                            </div>
                            <hr class="mt-2 mb-1">
                        </div>

                        <label class="form-label">Fuel Percent of Dray</label>
                        <input class="form-control mb-3" type="number" [(ngModel)]="preference.fuelPctOfDray">

                        <label class="form-label">Margin Storage Percent</label>
                        <input class="form-control mb-3" type="number" [(ngModel)]="preference.marginStoragePerc">

                        <label class="form-label">Storage Rate Per Day for Client</label>
                        <input class="form-control mb-3" type="number"
                            [(ngModel)]="preference.storageRatePerDayForClient">

                    </div>
                    <div class="col-2">&nbsp;</div>
                    <div class="col-5">

                        <div class="mt-3 row">
                            <div class="d-grid gap-3 d-md-flex justify-content-start">
                                <h5 class="modal-title" style="font-size: 17px;">
                                    Driver's Configuration
                                </h5>
                            </div>
                            <hr class="mt-2 mb-1">
                        </div>

                        <label class="form-label">Driver Percent of Dray</label>
                        <input class="form-control mb-3" type="number" [(ngModel)]="preference.driverDrayPercent">

                        <label class="form-label">Driver Commission Percent</label>
                        <input class="form-control mb-3" type="number" [(ngModel)]="preference.driverCommissionPerc">

                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
                    Cancel
                </button>
                <button (click)="UpdatePreferences()" type="button" class="btn btn-primary">
                    Save
                </button>
            </div>

        </div>
    </div>
</div>
